/**
 * 格式化货币显示
 * @param amount 金额，单位为最小单位（例如：美分）
 * @param currency 货币代码
 * @returns 格式化后的货币字符串
 */
export const formatCurrency = (amount: number, currency: string = 'USD'): string => {
  if (!amount) return '0';
  
  // 将金额从最小单位转换为主要单位（例如：从美分转为美元）
  const mainUnitAmount = amount / 100;
  
  // 设置货币符号
  const currencySymbol = currency === 'CNY' ? '¥' : currency === 'USD' ? '$' : '';
  
  // 格式化数字，保留两位小数
  return `${currencySymbol}${mainUnitAmount.toFixed(2)}`;
};

/**
 * 格式化日期
 * @param timestamp Unix时间戳
 * @param language 语言代码
 * @returns 格式化后的日期字符串
 */
export const formatDate = (timestamp: number, language: string = 'en'): string => {
  if (!timestamp) return '';
  
  const date = new Date(timestamp * 1000);
  
  // 根据语言使用不同的日期格式
  if (language === 'zh') {
    return date.toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } else {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
};

/**
 * 计算剩余天数
 * @param endTimestamp 结束时间的Unix时间戳
 * @returns 剩余天数
 */
export const getRemainingDays = (endTimestamp: number): number => {
  if (!endTimestamp) return 0;
  
  const now = new Date();
  const endDate = new Date(endTimestamp * 1000);
  
  // 计算天数差异
  const diffTime = endDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays > 0 ? diffDays : 0;
}; 